import { AddDocument } from '../../components/Library';

const NewDocument = () => <AddDocument />;

export default NewDocument;
